import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_88: DocMigration = {
  maxSchemaVersion: "0.0.88",
  description: "UNCATEGORIZED is now the default SalesCategory enum",
  apply(json: any) {
    if (json.params) {
      for (const key of Object.keys(json.params)) {
        const param = json.params[key];
        if (param.config && !param.config.salesCategory) {
          (param as any).config.salesCategory = "UNCATEGORIZED";
        }
      }
    }

    return json;
  },
};

export default migration_0_0_88;
